import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { RoutePath } from 'router/router.config';
import { selectRegistrationStep } from 'store/slices/registration';
import { useAppSelector } from 'store/store.hooks';

export const useRedirectIfPrevFormIsNotCompleted = (
  step: 'contactDataStep' | 'personalDataStep',
) => {
  const contactDataStep = useAppSelector(
    selectRegistrationStep('contactDataStep'),
  );
  const personalDataStep = useAppSelector(
    selectRegistrationStep('personalDataStep'),
  );
  const navigate = useNavigate();
  const location = useLocation();

  const steps = {
    contactDataStep,
    personalDataStep,
  };

  const shouldSkipRedirect = () => {
    const searchParams = new URLSearchParams(location.search);
    return (
      searchParams.has('utm_campaign') ||
      searchParams.has('utm_source') ||
      searchParams.has('utm_medium') ||
      searchParams.has('omtrcid') ||
      searchParams.has('promoCode')
    );
  };

  useEffect(() => {
    if (!steps[step].isDirty && !shouldSkipRedirect()) navigate(RoutePath.Root);
  }, []);
};
